export default __webpack_public_path__ + "static/media/prepleaf-logo.180c1653.svg";